import {Component, OnInit, Input, AfterViewInit, ChangeDetectorRef} from '@angular/core';
import {Subject} from 'rxjs';
@Component({
  selector: 'app-youtube-video',
  template: `
<div id="showing-hiding" [ngStyle]="{'display': youtubeError ? 'none' : ''}">
    <div class="max-width-1024">
      <div  id="player" ></div>
      </div>
</div>
<!--<div id="place-holder" [ngStyle]="{'display': youtubeError ? 'flex' : 'none'}">-->
<!--No Video-->
<!--</div>-->

    `,
  styles: [`.max-width-1024 { max-width: 1024px; margin: 0 auto; }` // ,
            // `#place-holder {
            //     width: 320px;
            //     height: 240px;
            //     background-color: lightgray;
            //     justify-content: center;
            //     flex-direction: column;
            //     align-items: center;
            // }`
    ],
})
export class YoutubeComponent implements OnInit, AfterViewInit {
  public YT: any;
  public video: any;
  public player: any;
  public reframed: Boolean = false;
  public youtubeError = true;
  private ready = false;
  videoPending = false;

  constructor(private _changeDetectorRef :ChangeDetectorRef ) {
    console.log('VIDEO  creating youtube component');

   }

  init() {
    console.log('INIT FUNCTION');
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    if (window['YT'] && window['YT'].loaded) {
      console.log('VIDEO youtube is already loaded');
      this.onFrameReady();
    }
    window['onYouTubeIframeAPIReady'] = () => {
      this.onFrameReady();
    };
  }

  onFrameReady() {

    if (this.videoPending && this.video !== '') {
      this.play();
    }
    this.ready = true;
    this.videoPending = false;
  }

  @Input()
  set videoId(videoId: string) {

    this.video = videoId;
    if (this.ready) {
      this.play();
    } else {
      this.videoPending = true;
    }
   }

  ngOnInit() {
    console.log('VIDEO NG INIT');
    this.init();
    console.log('VIDEO before iframe ready');
  }

  ngAfterViewInit() {
    console.log('VIDEO AFTER VIEW INIT');
  }

  play() {
    console.log('VIDEO PLAY');

    if (this.player) {
      console.log('loading video by ID');
      this.player.loadVideoById(this.video);
    } else {
      this.loadVideo();
    }
  }

  loadVideo() {
    console.log('VIDEO LOAD VIDEO');
    console.log('VIDEO loading ', this.video);
    this.YT = window['YT'];
    this.reframed = false;
    this.player = new window['YT'].Player('player', {
      height: '360',
      width: '480',
      videoId: this.video,
      playerVars: { 'autoplay': 0},
      events: {
        'onStateChange': this.onPlayerStateChange.bind(this),
        'onError': this.onPlayerError.bind(this),
        'onReady': (e) => {
          this.ready = true;
          this.youtubeError = false;
          console.log('VIDEO after subscription');
          if (!this.reframed) {
            this.reframed = true;
            // reframe(e.target.a);

          }
        }
      }
    });
    this.youtubeError = false;
    this._changeDetectorRef.detectChanges();
  }

  onPlayerStateChange(event) {
    console.log('on player state changed');
    // console.log(event);
    this.youtubeError = false;
    switch (event.data) {
      case window['YT'].PlayerState.PLAYING:
        if (this.cleanTime() === 0) {
          // console.log('started ' + this.cleanTime());
        } else {
          // console.log('playing ' + this.cleanTime());
        }
        break;
      case window['YT'].PlayerState.PAUSED:
        if (this.player.getDuration() - this.player.getCurrentTime() !== 0) {
          // console.log('paused' + ' @ ' + this.cleanTime());
        }
        break;
      case window['YT'].PlayerState.ENDED:
        console.log('ended ');
        break;
    }
  }

  // utility
  cleanTime() {
    return Math.round(this.player.getCurrentTime());
  }

  onPlayerError(event) {
      console.log('error on youtube video');
      this.youtubeError = true;
      // console.log(event);
    switch (event.data) {
      case 2:
        // console.log('' + this.video);
        break;
      case 100:
        break;
      case 101 || 150:
        break;
    }
  }
}
